import { Box, styled } from '@mui/material';

import { COLORS } from '../../../../../configs/colors';

export const SectionContainer = styled(Box)`
  background-color: ${COLORS.White};
  margin: 8px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const SectionHeader = styled(Box)`
  padding: 12px 16px;
  background-color: ${COLORS.NavyBlue};
  color: ${COLORS.White};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SectionTitle = styled(Box)`
  font-size: 14px;
  font-weight: 600;
`;

export const FilterTabs = styled(Box)`
  display: flex;
  gap: 4px;
  padding: 8px 16px;
  border-bottom: 1px solid ${COLORS.SubtleGrey};
  background-color: ${COLORS.LightBlueBackground};
`;

export const FilterTab = styled('button', {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active?: boolean }>`
  padding: 10px 16px;
  border: none;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  min-height: 36px;
  cursor: pointer;
  background-color: ${({ active }) => (active ? COLORS.NavyBlue : 'transparent')};
  color: ${({ active }) => (active ? COLORS.White : COLORS.Gray)};
  transition: all 0.2s;

  &:hover {
    background-color: ${({ active }) => (active ? COLORS.NavyBlue : COLORS.SubtleGrey)};
  }
`;

export const SectionContent = styled(Box)`
  overflow-y: auto;
`;

export const ContentWrapper = styled(Box)`
  padding: 16px;
`;

export const AttachmentList = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const AttachmentItem = styled(Box)`
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid ${COLORS.SubtleGrey};
  gap: 12px;

  &:last-child {
    border-bottom: none;
  }
`;

export const AttachmentIcon = styled(Box)`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background-color: ${COLORS.LightBlueBackground};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${COLORS.NavyBlue};
`;

export const AttachmentInfo = styled(Box)`
  flex: 1;
  min-width: 0;
`;

export const AttachmentName = styled(Box)`
  font-size: 14px;
  font-weight: 500;
  color: ${COLORS.Black};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AttachmentMeta = styled(Box)`
  font-size: 12px;
  color: ${COLORS.Gray};
  margin-top: 2px;
`;

export const AttachmentActions = styled(Box)`
  display: flex;
  gap: 4px;
  flex-shrink: 0;
`;

export const EmptyState = styled(Box)`
  padding: 32px 0;
  text-align: center;
  color: ${COLORS.Gray};
  font-size: 14px;
`;

export const LoadingContainer = styled(Box)`
  padding: 32px 0;
  text-align: center;
`;

export const ImagePreview = styled('img')`
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
`;

export const CountBadge = styled(Box)`
  font-size: 12px;
  color: ${COLORS.White};
  font-weight: 400;
  opacity: 0.8;
`;
